<template>
  <v-card class="px-5 py-3 budget-details-card">
    <div class="d-flex flex-column">
      <div class="d-flex justify-space-between py-2">
        <div style="width: 85px">
          <p class="ma-0 subheader">Витрачено</p>
          <p class="mt-1 ma-0 value">₴{{spent | numberify}}</p>
        </div>
        <div style="width: 85px">
          <p class="ma-0 subheader">Залишилось</p>
          <p class="mt-1 ma-0 value">₴{{left | numberify}}</p>
        </div>
        <div style="width: 85px">
          <p class="ma-0 subheader">Бюджет</p>
          <p class="mt-1 ma-0 value">₴{{total | numberify}}</p>
        </div>
      </div>


    </div>
  </v-card>
</template>

<script>
export default {
  name: 'BudgetDetailsCard',

  props: {
    spent: {
      type: Number,
      required: true
    },
    total: {
      type: Number,
      required: true
    }
  },

  computed: {
    left() {
      return this.total - this.spent;
    }
  },

  filters: {
    numberify: function (value) {
      if (!value) return '0';
      return new Intl.NumberFormat().format(Math.trunc(value));
    }
  }
}
</script>

<style scoped>
.budget-details-card {
  border-radius: 16px;
  box-shadow: 0px 16px 64px -32px rgba(0, 0, 0, 0.24) !important;
}

.subheader {
  font-family: 'Inter';
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: -0.12px;
  color: #5C616F;
}

.value {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 17px;
  line-height: 24px;
  letter-spacing: -0.4px;
  color: #040C22;
}

.progress-section {
  margin-top: 8px;
}
</style>
